module.exports = __webpack_public_path__ + "img/ico-inqueue.edceec28.svg";